 <div class="container-large">
  <div class="section-header short-line">
    <h2 class="section-title">{{this.word[this.language].selectedForYou}}</h2>
  </div>
  <div class="home-selected-cards">
    <div class="venue-skeleton" *ngIf="!loaded" style="width: 260px;">
      <ngx-skeleton-loader count="1" animation="progress" appearance="circle" loadingText="Venue Name" [theme]="{
            width: '100%',
            'border-radius': '6px',
            height: '250px',
            'margin-left': '0',
            'margin-right': '0',
            'margin-top': '5px',
            'margin-bottom': '0px'
          }">

      </ngx-skeleton-loader>
      <ngx-skeleton-loader count="1" animation="progress" [theme]="{
            width: '70%',
            'border-radius': '0',
            height: '15px',
            'margin-left': '0',
            'margin-right': '0',
            'margin-bottom': '5px',
            'margin-top': '5px'
          }"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1" animation="progress" [theme]="{
            width: '60%',
            'border-radius': '0',
            height: '15px',
            'margin-left': '0',
            'margin-right': '0',
            'margin-bottom': '5px',
            'margin-top': '5px'
          }"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1" animation="progress" [theme]="{
            display: 'block',
            width: '20%',
            'border-radius': '0',
            height: '15px',
            'margin-left': '0',
            'margin-right': '0'
          }"></ngx-skeleton-loader>
    </div>

    <!-- <swiper [navigation]="{ prevEl: prevEl, nextEl: nextEl }" [freeMode]="true" [breakpoints]="{
        '320': {
          slidesPerView: '1.5'

        },
        '420': {
          slidesPerView: '1.9'

        },
        '580': {
          slidesPerView: '2.8'
        },
        '768': {
          slidesPerView: '3.4'
        },
        '991': {
          slidesPerView: '4.7'
        },
        '1280':{
          slidesPerView: '5.6'
        }
      }" id="home-selected-slider">
      <ng-template swiperSlide *ngFor="let venue of selectedForYou" class="home-selected">
        <selected-card
          [routerLink]="'/' + language == 'en'
          ? language + '/' + venue?.id + '/' + toLatin(venue?.name)
          : venue?.id + '/' + toLatin(venue?.name)"

          [venueData]="venue">
        </selected-card>
      </ng-template>
    </swiper> -->
    <swiper-container
     init="false"
     [config]="this.config"
     appSwiper
     #selectedSlider
     id="home-selected-slider">
      <swiper-slide
       *ngFor="let venue of selectedForYou" class="home-selected">
          <selected-card
          [routerLink]="'/' + language == 'en'
          ? language + '/' + venue?.id + '/' + toLatin(venue?.name)
          : venue?.id + '/' + toLatin(venue?.name)"

          [venueData]="venue">
        </selected-card>
      </swiper-slide>
      </swiper-container>
        <div class="swiper-navigation">
          <button type="button" id="prev-selected" class="swiper-arrows swiper-navigation-prev" aria-label="Go to next slide"><i
              class="fa fa-chevron-left" aria-hidden="true"></i></button>
          <button type="button" id="next-selected" class="swiper-arrows swiper-navigation-next" aria-label="Go to previous slide"><i
              class="fa fa-chevron-right" aria-hidden="true"></i></button>
        </div>

  </div>
</div>
